document.addEventListener('DOMContentLoaded',function(){
  var main=document.getElementById('CalmPawMainImage');
  document.querySelectorAll('.thumb[data-image]').forEach(function(btn){
    btn.addEventListener('click',function(){
      if(main){main.src=btn.getAttribute('data-image');main.alt=btn.getAttribute('data-alt')||'CalmPaw product image';}
      document.querySelectorAll('.thumb').forEach(function(t){t.classList.remove('is-selected');t.setAttribute('aria-pressed','false')});
      btn.classList.add('is-selected');btn.setAttribute('aria-pressed','true');
    });
  });

  var productForm=document.getElementById('CalmPawProductForm');
  if(productForm){
    var quantityInput=productForm.querySelector('#CalmPawQuantity');
    var quantityCards=productForm.querySelectorAll('.quantity-offer[data-quantity]');
    function setQuantity(q){
      q=Math.max(1,Math.floor(Number(q)||1));
      if(quantityInput)quantityInput.value=q;
      quantityCards.forEach(function(card){
        var selected=Number(card.getAttribute('data-quantity'))===q;
        card.classList.toggle('is-selected',selected);
        card.setAttribute('aria-pressed',selected?'true':'false');
      });
      var button=productForm.querySelector('.buy-button');
      if(button&&!button.disabled){button.innerHTML=(q>1?'Add '+q+' to cart':'Add to cart')+' <span>→</span>';}
      var note=productForm.querySelector('.bundle-disclaimer');
      if(note){note.textContent=q>=3?'15% off 3 or more CalmPaw devices. The eligible discount is applied when you continue to checkout.':(q===2?'10% off when you buy 2 CalmPaw devices. The eligible discount is applied when you continue to checkout.':'Choose 2 devices for 10% off or 3+ for 15% off. Your eligible CalmPaw discount code is applied when you continue to checkout.');}
    }
    quantityCards.forEach(function(card){card.addEventListener('click',function(){setQuantity(card.getAttribute('data-quantity'));});});
    if(quantityInput){
      quantityInput.addEventListener('change',function(){setQuantity(quantityInput.value);});
      quantityInput.addEventListener('input',function(){
        var q=Math.max(1,Math.floor(Number(quantityInput.value)||1));
        quantityCards.forEach(function(card){var selected=Number(card.getAttribute('data-quantity'))===q;card.classList.toggle('is-selected',selected);card.setAttribute('aria-pressed',selected?'true':'false');});
      });
    }
    productForm.addEventListener('submit',function(){
      var b=productForm.querySelector('.buy-button');
      if(b&&!b.disabled){b.dataset.original=b.innerHTML;b.innerHTML='Adding…';setTimeout(function(){if(b.dataset.original)b.innerHTML=b.dataset.original;},2500);}
    });
  }
  var toggle=document.querySelector('.mobile-menu-toggle'),nav=document.getElementById('CalmPawNavigation');
  if(toggle&&nav){toggle.addEventListener('click',function(){var open=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',open?'false':'true');toggle.setAttribute('aria-label',open?'Open navigation':'Close navigation');nav.classList.toggle('is-open',!open)});nav.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){toggle.setAttribute('aria-expanded','false');toggle.setAttribute('aria-label','Open navigation');nav.classList.remove('is-open')})})}
  document.querySelectorAll('.nav-dropdown').forEach(function(drop){drop.addEventListener('keydown',function(e){if(e.key==='Escape'){drop.open=false;drop.querySelector('summary').focus()}})});
});